import { useEffect, useMemo } from 'react'
import { intl } from '../../../../../i18n'
import { WbsItemAdditionalPropertyLayoutEntity } from '../../../../../domain/entity/WbsItemAdditionalPropertyLayoutEntity'
import { FunctionPropertyConfigurationState } from '../functionPropertyConfiguration'
import { useWbsItemLabel } from '../label'

export const useTicketLabel = (
  wbsItemAdditionalProperties:
    | WbsItemAdditionalPropertyLayoutEntity
    | undefined,
  functionPropertyConfiguration: FunctionPropertyConfigurationState
) => {
  const labelMap = useWbsItemLabel(
    wbsItemAdditionalProperties,
    functionPropertyConfiguration
  )
  useEffect(() => {
    /** For change logs. */
    labelMap.set('ticketListUuid', intl.formatMessage({ id: 'ticketList' }))
  }, [labelMap])

  return labelMap
}
